import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '~/hooks/useHttpClient';
import { sanitizeTagValue } from '~/utils/instrumentation';
import { createLogger } from '~/utils/logging';
import { ClientError } from '~/errors';

const log = createLogger('useEmailPasswordSignupMutation');

export type EmailPasswordSignUpRequest = {
  name: string;
  email: string;
  password: string;
  tosAgreedAt: string;
  turnstileToken: string;
};

export type EmailPasswordSignUpResponse = {
  user: {
    name: string;
    email: string;
    emailVerified: boolean;
  };
};

export function useEmailPasswordSignupMutation() {
  const httpClient = useHttpClient();

  const { mutate, status } = useMutation({
    mutationFn: async (request: EmailPasswordSignUpRequest) => {
      log.debug('Signing up user with email/password');
      const { user } = await httpClient.post<EmailPasswordSignUpResponse>('/auth/signUp', request);
      log.info('Signed up user successfully');
      return { user };
    },
    onError: (err: Error) => {
      if (err instanceof ClientError) {
        // Ignore client errors — handled at the call site.
      } else {
        log.error('Failed to sign up user', {
          errorMessage: sanitizeTagValue(err.message),
        });
      }
    },
  });

  return { mutate, status };
}
